module.exports = __webpack_public_path__ + "1642699981952/static/media/authBastaoAzul.c247d0fa.svg";